<template>
 <Dialog :visible="visible" modal data-testid="devtip-library-dialog"
    :header="$t('DevTipLibraryOverlayComponent.yourTips', {text: featureNameDevTip})"
    :style="{ width: '50rem' }" class="mx-4"
    @update:visible="$emit('update:visible', $event)">
      <div>
        <div v-if="!loading">
          <dev-tip-item-component v-for="item in getDevTippOverview"
                                  :key="item.tip_id || item._id || item"
                                  :tip="item"
                                  :show-text="true"
                                  @viewed="refreshLibrary"
                                  />
          <p v-if="!getDevTippOverview || getDevTippOverview.length === 0">
            {{ $t('DevTipLibraryOverlayComponent.noTips', {text: featureNameDevTip}) }}
          </p>
        </div>
        <div v-else style="display: flex; justify-content: center">
          <img class="w-32 h-32" src="@/assets/loadingSpinner.svg" alt="txt" />
        </div>
      </div>
  </Dialog>
</template>

<script>
import DevTipItemComponent from '@/components/Home/Shared/DevTip/DevTipItemComponent.vue';
import { Dialog } from 'primevue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'DevTipLibraryOverlayComponent',
  emits: ['update:visible'],
  props: {
    // Parent (DevTipComponent) binds :visible / @update:visible — keep that contract.
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: { DevTipItemComponent, Dialog },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    getDevTippOverview() {
      return this.$store.getters.getDevTippOverview;
    },
    featureNameDevTip() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'developmentTip',
        this.$t('FallbackTexts.developmentTip'),
        this.$i18n?.locale,
      );
    },
  },
  methods: {
    // Keep the unread marker in sync after a single tip was opened.
    refreshLibrary() {
      this.$store.dispatch('getDevTippOverview').catch(() => {});
    },
  },
  watch: {
    visible: {
      async handler(isVisible) {
        if (isVisible) {
          this.loading = true;
          await this.$store.dispatch('getDevTippOverview');
          this.loading = false;
        }
      },
    },
  },
  mounted() {
    this.loading = false;
  },
};
</script>
